import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Task\GetTaskListController::__invoke
* @see app/Http/Controllers/Task/GetTaskListController.php
* @route '/api/task'
*/
const GetTaskListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTaskListController.url(options),
    method: 'get',
})

GetTaskListController.definition = {
    methods: ["get","head"],
    url: '/api/task',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Task\GetTaskListController::__invoke
* @see app/Http/Controllers/Task/GetTaskListController.php
* @route '/api/task'
*/
GetTaskListController.url = (options?: RouteQueryOptions) => {
    return GetTaskListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Task\GetTaskListController::__invoke
* @see app/Http/Controllers/Task/GetTaskListController.php
* @route '/api/task'
*/
GetTaskListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTaskListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Task\GetTaskListController::__invoke
* @see app/Http/Controllers/Task/GetTaskListController.php
* @route '/api/task'
*/
GetTaskListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTaskListController.url(options),
    method: 'head',
})

export default GetTaskListController